import { render, staticRenderFns } from "./ListGardenPlans.vue?vue&type=template&id=860cf90a"
import script from "./ListGardenPlans.vue?vue&type=script&lang=js"
export * from "./ListGardenPlans.vue?vue&type=script&lang=js"
import style0 from "./ListGardenPlans.vue?vue&type=style&index=0&id=860cf90a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports